import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService, BASE_URL_CRUD, BASE_URL_REPORTS } from '../app.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
@Injectable()
export class CommunityService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  postCommunity(administrationId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administration/${administrationId}/community/create`;
    return this.post(this.endpoint, data);
  }

  getCommunityById(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/id/${communityId}`;
    return this.get(this.endpoint);
  }

  updateCommunity(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}`;
    return this.put(this.endpoint, data);
  }

  getUnits(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/type`;
    return this.get(this.endpoint);
  }

  getUnitsHistory(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/list`;
    return this.get(this.endpoint);
  }

  getUnitsAssigmenHistory(communityId: number, unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/${unitId}/history`;
    return this.get(this.endpoint);
  }

  postDeleteUnitAssignedHistory(communityId: number, unitId: number, unit_property_ids: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/${unitId}/history/delete`;
    return this.post(this.endpoint, {unit_property_ids});
  }

  getUnitsByCommunity(communityId: number, sectorId?: number, dataTablesParameters?: any): Observable<any> {
    let query = '';
    if (sectorId) {
      query = `?sector_id=${sectorId}`;
    }
    const join = query === '' ? '?' : '&';
    if (dataTablesParameters) {
      const start = dataTablesParameters.start ? dataTablesParameters.start : 0;
      const length = dataTablesParameters.length ? dataTablesParameters.length : null;
      const findValue = dataTablesParameters.search.value ? dataTablesParameters.search.value : '';
      query = `${query}${join}draw=${start}&length=${length}&value=${findValue}`;
    }
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units${query}`;
    return this.get(this.endpoint);
  }

  getUnitsByCommunityWithOutProperties(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/without-properties`;
    return this.get(this.endpoint);
  }

  postUnit(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/create`;
    return this.post(this.endpoint, data);
  }

  getUnitById(communityId: number, unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/${unitId}`;
    return this.get(this.endpoint);
  }

  updateUnit(communityId: number, data: any, unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/${unitId}`;
    return this.put(this.endpoint, data);
  }

  deleteUnit(communityId: number, unitId: number) {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/${unitId}`;
    return this.delete(this.endpoint);
  }
  getPeriodClose(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/common-expenses/${communityId}/period-close`;
    return this.get(this.endpoint);
  }

  postCommunitySettingsDebtType(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/defaulters-parameters`;
    return this.post(this.endpoint, data);
  }

  changeOwner(unitId: number, data): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/units/${unitId}/change-owner`;
    return this.post(this.endpoint, data);
  }

  getHistoryUnitUser(unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/units/${unitId}/user-history`;
    return this.get(this.endpoint);
  }

  getEmailPayment(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/config/email-payment`;
    return this.get(this.endpoint);
  }

  postEmailPayment(communityId: number, data): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/config/email-payment`;
    return this.post(this.endpoint, data);
  }

  exportCommunityFile(communityId: number, unitsType: any): Observable<any> {
    const data = {
      community: communityId,
      data: unitsType
    };

    this.endpoint = `${BASE_URL_REPORTS}/import-community-xls`;
    return this.generate(this.endpoint, data);
  }

  getUnitUnassign(communityId: number, unitId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/unassign/${unitId}`;
    return this.get(this.endpoint);
  }

  getAddressCommunity(communityId: number): Observable<any> {
    return this.getCommunityById(communityId).map(community => {
      return community.settings.find(x => x.communitySettingsField.key === 'COMMUNITY_ADDRESS');
    });
  }

  getImageCommunity(communityId: number): Observable<any> {
    return this.getCommunityById(communityId).map(community => {
      return community.settings.find(x => x.communitySettingsField.key === 'COMMUNITY_IMAGE');
    });
  }
  getContactData(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/community/${communityId}/assigned-contact`;
    return this.get(this.endpoint);
  }
}





// WEBPACK FOOTER //
// ./src/app/services/community.service.ts